export default __webpack_public_path__ + "static/media/cosyfish-map.ccbfa105.png";